var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Search_Bar","data-name":"Search Bar","transform":"translate(1 1)"},React.createElement("path",{"id":"Search","d":"M15.681,15.681,20,20ZM0,8.967a8.967,8.967,0,1,1,8.967,8.966A8.967,8.967,0,0,1,0,8.967Z","fill":"none","stroke":"#555962","strokeLinecap":"round","strokeWidth":"2"})));
}

SearchInline.defaultProps = {"width":"21.707","height":"21.707","viewBox":"0 0 21.707 21.707"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
